<template>
  <v-container grid-list-xl>
    <v-layout row wrap justify-center align-center>
      <v-btn large flat icon color="#003a3e ">
        <v-icon class>fa-trophy</v-icon>
      </v-btn>
      <h1 style="color: #003a3e">Torneios</h1>
    </v-layout>
    <v-container fill-height>
      <v-layout
        v-if="allChampionships && allChampionships.length == 0"
        row
        justify-center
        align-center
      >Nenhum campeonato criado.</v-layout>
    </v-container>

    <v-layout row wrap class="mt-2" v-if="allChampionships">
      <v-flex xs12 sm6 lg4 v-for="championship in allChampionships" :key="`${championship.id}-lay`">
        <v-card class="primary" style="border-radius: 12px">
          <v-container fluid>
            <v-layout row>
              <v-flex xs7>
                <v-avatar :size="avatarSize" color="white" id="axis">
                  <v-img
                    v-if="championship.attributes.logo"
                    :src="championship.attributes.logo"
                    aspect-ratio="1"
                    class="grey lighten-4"
                    style="border-radius: 12px"
                    contain
                  ></v-img>
                  <v-icon
                    v-if="!championship.attributes.logo"
                    large
                    :class="[' mdi-48px', (going && id==championship.id)? 'theball mdi-spin' : '']"
                    color="primary"
                  >mdi-soccer</v-icon>
                  <v-icon
                    v-if="!championship.attributes.logo"
                    large
                    :class="['mdi-rotate-135', (going && id==championship.id)? 'movecourt' : '']"
                  >mdi-soccer-field</v-icon>
                  <v-icon
                    v-if="!championship.attributes.logo"
                    large
                    :class="[(going && id==championship.id)? 'movestadium' : '']"
                  >mdi-stadium</v-icon>
                </v-avatar>
              </v-flex>
              <v-flex xs7 sm8 md9>
                <v-chip
                  small
                  color="yellow darken-4"
                  dark
                  v-if="checkWinners(championship)"
                >Finalizado</v-chip>
                <v-card-title primary-title>
                  <h3 class="white--text mb-2">{{championship.attributes.name}}</h3>
                </v-card-title>
                <v-card-actions>
                  <v-btn round color="white" class="primary--text" @click="go_to(championship)">
                    Detalhes
                    <v-icon right light>arrow_forward</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>

    <template v-if="!getAllChampionships || going">
      <card-loading load-text="Carregando"></card-loading>
    </template>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      going: false,
      id: null,
      avatarSize: 128
    };
  },
  computed: {
    is_mobile() {
      return document.body.clientWidth < 800;
    },
    ...mapState({
      oneChampionship: state => state.Championship.oneChampionship,
      allChampionships: state => state.Championship.allChampionships
    })
  },
  methods: {
    checkWinners(champ) {
      if (champ.attributes.edition.data[0].attributes.winners.data.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    go_to(champ) {
      this.going = true;
      let id = [...champ.attributes.edition_modality_ids];
      setTimeout(() => {
        this.$router.push(`/campeonatos/${id.pop()}/jogos`);
      }, 500);
    },
    ...mapActions({
      show: "Championship/show",
      getAllChampionships: "Championship/index"
    })
  },
  created() {
    this.getAllChampionships();
  }
};
</script>

<style l scoped>
#axis:hover .moveball {
  position: relative;
  -webkit-animation: myfootie 2s infinite; /* Safari 4.0 - 8.0 */
  animation: myfootie 2s infinite;

  /* transform: translate(72px,0); */
  /*-webkit-transform: translate(72px,0); /** Chrome & Safari **/
  /*-o-transform: translate(72px,0); /** Opera **/
  /*-moz-transform: translate(72px,0); /** Firefox **/
}

.movecourt {
  position: relative;
  -webkit-animation: mycourt 2s infinite; /* Safari 4.0 - 8.0 */
  animation: mycourt 2s infinite;

  /* transform: translate(72px,0); */
  /*-webkit-transform: translate(72px,0); /** Chrome & Safari **/
  /*-o-transform: translate(72px,0); /** Opera **/
  /*-moz-transform: translate(72px,0); /** Firefox **/
}

.movestadium {
  position: relative;
  -webkit-animation: mystadium 2s infinite; /* Safari 4.0 - 8.0 */
  animation: mystadium 2s infinite;

  /* transform: translate(72px,0); */
  /*-webkit-transform: translate(72px,0); /** Chrome & Safari **/
  /*-o-transform: translate(72px,0); /** Opera **/
  /*-moz-transform: translate(72px,0); /** Firefox **/
}

.theball {
  position: relative;
  /* transition: all 1s ease-in-out; */
  /*-moz-animation: myfootie 2s infinite; /* Firefox */
  -webkit-animation: myfootie 2s infinite; /* Safari 4.0 - 8.0 */
  animation: myfootie 2s infinite;
  /*-webkit-transition: all 1s ease-in-out; /** Chrome & Safari **/
  /*-moz-transition: all 1s ease-in-out; /** Firefox **/
  /*-o-transition: all 1s ease-in-out; /** Opera **/
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes myfootie {
  0% {
    left: 0px;
  }
  50% {
    left: 80px;
  }
  100% {
    left: 0px;
  }
}
@-moz-keyframes myfootie {
  0% {
    left: 0px;
  }
  50% {
    left: 80px;
  }
  100% {
    left: 0px;
  }
}
@-o-keyframes myfootie {
  0% {
    left: 0px;
  }
  50% {
    left: 80px;
  }
  100% {
    left: 0px;
  }
}
@keyframes myfootie {
  0% {
    left: 0px;
  }
  50% {
    left: 80px;
  }
  100% {
    left: 0px;
  }
}

@-webkit-keyframes mycourt {
  0% {
    top: 0px;
  }
  50% {
    top: -40px;
  }
  100% {
    top: 0px;
  }
}
@-moz-keyframes mycourt {
  0% {
    top: 0px;
  }
  50% {
    top: -40px;
  }
  100% {
    top: 0px;
  }
}
@-o-keyframes mycourt {
  0% {
    top: 0px;
  }
  50% {
    top: -40px;
  }
  100% {
    top: 0px;
  }
}
@keyframes mycourt {
  0% {
    top: 0px;
  }
  50% {
    top: -40px;
  }
  100% {
    top: 0px;
  }
}

@-webkit-keyframes mystadium {
  0% {
    transform: translatex(0px) translatey(0px);
  }
  50% {
    transform: translatex(-40px) translatey(40px);
  }
  100% {
    transform: translatex(0px) translatey(0px);
  }
}

@-moz-keyframes mystadium {
  0% {
    transform: translatex(0px) translatey(0px);
  }
  50% {
    transform: translatex(-40px) translatey(40px);
  }
  100% {
    transform: translatex(0px) translatey(0px);
  }
}

@-o-keyframes mystadium {
  0% {
    transform: translatex(0px) translatey(0px);
  }
  50% {
    transform: translatex(-40px) translatey(40px);
  }
  100% {
    transform: translatex(0px) translatey(0px);
  }
}
@keyframes mystadium {
  0% {
    transform: translatex(0px) translatey(0px);
  }
  50% {
    transform: translatex(-40px) translatey(40px);
  }
  100% {
    transform: translatex(0px) translatey(0px);
  }
}

@-webkit-keyframes bacon {
}

@-moz-keyframes bacon {
}

@-o-keyframes bacon {
}

@keyframes bacon {
}
</style>